module.exports = __webpack_public_path__ + "img/search.f01c33e5.svg";